import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["angle", "children", "colors", "end", "locations", "start", "style", "useAngle"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useViewSize } from '@bubble-ui/hook-use-view-size';
import { View } from '@bubble-ui/primitive-view';
// Built from https://github.com/react-native-web-community/react-native-web-linear-gradient/blob/master/src/index.js
var LinearGradient = _ref => {
  var {
      angle,
      children,
      colors = [],
      end = {
        x: 0.5,
        y: 1
      },
      locations = [],
      start = {
        x: 0.5,
        y: 0
      },
      style,
      useAngle
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var [containerProps, size] = useViewSize();
  var {
    width = 1,
    height = 1
  } = size;
  var calculatedAngle = useAngle && angle !== undefined ? "".concat(angle, "deg") : // Math.atan2 handles Infinity
  "".concat(Math.atan2(width * (end.y - start.y), height * (end.x - start.x)) + Math.PI / 2, "rad");
  var getColors = () => colors.map((color, index) => {
    var location = locations[index];
    var locationStyle = '';
    if (location) {
      locationStyle = " ".concat(location * 100, "%");
    }
    return color + locationStyle;
  }).join(',');
  return /*#__PURE__*/React.createElement(View, _extends({}, containerProps, {
    style: _objectSpread({
      // @ts-expect-error
      backgroundImage: "linear-gradient(".concat(calculatedAngle, ", ").concat(getColors(), ")"),
      flexGrow: 1,
      width: 'auto'
    }, style)
  }, props), children);
};
LinearGradient.displayName = 'LinearGradient';
export { LinearGradient };
//# sourceMappingURL=index.js.map